import { requestCreate, requestDelete, requestUpdate, sendRequest } from "../api"
import { ADD_IN_LIST, REMOVE_IN_LIST, RESET_FORM, RESET_STATE, SET_FORM, SET_LIST, SET_LOADING, UPDATE_IN_LIST } from "../constant-types";
import { defaultSetListMutation, defaultSetLoading } from "../default-method";
import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
    return {
        list: null,
        form : getDefaultFormState(),
        loading: false,
    };
};

const getDefaultFormState = () => {
    return {
        id : '',
        start_date: null,
        category_id: null,
        name: '',
        nominal : 0,
        qty: 1,
        unit_name : 'pcs',
        from_user_cash_id: null,
        paid_date: null,
        status_paid: false
    };
}

export default {
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState());
        },
        ...defaultSetListMutation,
        ...defaultSetLoading,
        [ADD_IN_LIST](state, newAsset) {
            state.list.unshift(newAsset)
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, payload)
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [REMOVE_IN_LIST](state, asset) {
            let idx = state.list.findIndex(l => l.id == asset.id);
            state.list.splice(idx, 1);
        },
        [UPDATE_IN_LIST](state, asset) {
            let idx = state.list.findIndex(l => l.id == asset.id);
            state.list.splice(idx, 1, asset)
        },
        updateField
    },
    // can async
    actions: {
        loadList({ commit, state }) {
            commit(SET_LOADING, true)
            return sendRequest('asset', {}, 'get', (fetchedList) => {
                commit(SET_LOADING, false)
                commit(SET_LIST, fetchedList)
            })
        },
        requestCreateAsset({state, commit}) {
            requestCreate('asset', state.form, commit)
        },
        requestUpdateAsset({state, commit}) {
            requestUpdate('asset', state.form, commit)
        },
        requestDeleteAsset({commit}, asset) {
            requestDelete('asset/'+asset.id, {}, commit, asset.name)
        },
    },
    // call variable with custom display
    getters: {
        listGrouped: state => {
            if (!state.list) return 

            let groups = _.groupBy(state.list, 'category_id')
            let mapped  = _.map(groups, function (i, iKey) {
                return {
                    category_id : iKey,
                    list : i,
                    sum_nominal : _.sumBy(i, 'nominal'),
                    counts : i.length
                }
            })

            return {
                sum_nominal : _.sumBy(state.list, 'nominal'),
                counts : state.list.length,
                details: mapped
            }
        },
        getField
    },
    // modules
    modules: {}
};
